import proposalSlice from './proposalSlice';

import * as proposalSelectors from './proposalSelector';
import * as proposalOperations from './proposalOperations';

export const proposalReducer = proposalSlice.reducer;
export const proposalActions = proposalSlice.actions;
export { proposalSelectors, proposalOperations };
